import { ActionReducerMap } from '@ngrx/store';
import { userReducer, UserState } from './reducers/user.reducer';
import { dataFlowReducer, DataFlowState } from './reducers/data-flow.reducer';

export interface AppState {
    user: UserState;
    dataFlow: DataFlowState;
}

const reducers: ActionReducerMap<AppState> = {
    user: userReducer,
    dataFlow: dataFlowReducer
}

export default {
    reducer: reducers
}
